import Vue from "vue";

const END_POINT = "/user";

const getUser = (id) => Vue.axios.get(END_POINT + "/" + id);

const getAllUsers = (data) => Vue.axios.get(END_POINT, { params: data });

const createUser = (user) => Vue.axios.post(END_POINT, user);

const createAllUsers = (Users) => Vue.axios.post(END_POINT + "/all", Users);

const updateUser = (user) => Vue.axios.put(END_POINT + "/" + user.id, user);

const deleteUser = (id) => Vue.axios.delete(END_POINT + "/" + id);

const resetUserPassword = (data) =>
  Vue.axios.post(END_POINT + "/reset-password", { ...data });

export {
  getUser,
  getAllUsers,
  createUser,
  createAllUsers,
  updateUser,
  deleteUser,
  resetUserPassword,
};
